import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogData } from "src/app/components";

@Component({
  selector: 'partnership-action-confirmation-dialog',
  templateUrl: './partnership-action-confirmation-dialog.component.html',
  styleUrls: ['./partnership-action-confirmation-dialog.component.less']
})
export class PartnershipActionConfirmationDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<PartnershipActionConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PartnershipConfirmationDialogData) {}

  cancelClick(): void {
    this.dialogRef.close();
  }
}

export interface PartnershipConfirmationDialogData {
  partnerName: string;
  request: boolean
}